import MaterialBox from "../../../../../__snowpack__/pkg/@mui/material/Box.js";
import styled from "styled-components";
export const OptionsContainer = styled(MaterialBox).withConfig({
  displayName: "tablestyles__OptionsContainer",
  componentId: "sc-1xsshx9-0"
})(["", ""], {
  "--tw-bg-opacity": "1",
  backgroundColor: "rgba(255, 255, 255, var(--tw-bg-opacity))",
  borderTopRightRadius: "1rem",
  borderBottomRightRadius: "1rem",
  borderTopLeftRadius: "1rem",
  borderBottomLeftRadius: "1rem",
  overflow: "hidden",
  display: "flex",
  alignItems: "stretch",
  justifyContent: "space-between",
  marginBottom: "1rem"
});
export const BoxContainer = styled(MaterialBox).withConfig({
  displayName: "tablestyles__BoxContainer",
  componentId: "sc-1xsshx9-1"
})(["", ""], {
  display: "flex",
  paddingTop: "0.5rem",
  paddingBottom: "0.5rem",
  paddingLeft: "1rem",
  paddingRight: "1rem"
});
export const TableContainer = styled(MaterialBox).withConfig({
  displayName: "tablestyles__TableContainer",
  componentId: "sc-1xsshx9-2"
})(["", ""], {
  borderWidth: "1px",
  "--tw-border-opacity": "1",
  borderColor: "rgba(229, 231, 235, var(--tw-border-opacity))",
  borderStyle: "solid",
  borderTopRightRadius: "1rem",
  borderBottomRightRadius: "1rem",
  borderTopLeftRadius: "1rem",
  borderBottomLeftRadius: "1rem",
  overflow: "hidden"
});
export const SelectOptionsContainer = styled(MaterialBox).withConfig({
  displayName: "tablestyles__SelectOptionsContainer",
  componentId: "sc-1xsshx9-3"
})(["", " & > *{", " & > span{", "}}& >:not(:last-child){", "}"], {
  display: "flex",
  alignItems: "stretch"
}, {
  paddingLeft: "0.5rem",
  paddingRight: "0.5rem",
  display: "flex",
  alignItems: "center",
  cursor: "pointer"
}, {
  cursor: "pointer"
}, {
  borderWidth: "0px",
  borderRightWidth: "2px",
  "--tw-border-opacity": "1",
  borderColor: "rgba(229, 231, 235, var(--tw-border-opacity))",
  borderStyle: "solid"
});
